module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"Privacy Policy","logout.success.title":"ออกจากระบบเรียบร้อย","logout.success.content":"คุณ {name} ออกจากระบบ @:common.application.title เรียบร้อย","consent.title":"กรุณาอ่านและยอมรับเงื่อนไขการใช้งาน","consent.agree":"ยอมรับเงื่อนไขการใช้งาน","consent.disagree":"ไม่ยอมรับเงื่อนไขการใช้งาน"}}')
  delete Component.options._Ctor
}
